// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"3475":"styles-52974198","3831":"styles-0d2bbdb8","5859":"styles-5c03d38f","7240":"styles-e96e9bea"}[chunkId] || chunkId) + ".bundle.js";
};